import { render, staticRenderFns } from "./index_Teachers_in.vue?vue&type=template&id=6c26f35a&scoped=true"
import script from "./index_Teachers_in.vue?vue&type=script&lang=js"
export * from "./index_Teachers_in.vue?vue&type=script&lang=js"
import style0 from "./index_Teachers_in.vue?vue&type=style&index=0&id=6c26f35a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c26f35a",
  null
  
)

export default component.exports